var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29046_12906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45856 4.89691L7.50022 1.88885L13.5419 4.89691C13.6371 4.94008 13.7479 4.9497 13.8511 4.92375C13.9543 4.8978 14.042 4.83829 14.0958 4.75765C14.1495 4.67701 14.1653 4.58149 14.1397 4.49102C14.1142 4.40056 14.0493 4.32215 13.9586 4.27219L7.50022 1.05469L1.04189 4.27219C0.992097 4.29476 0.948087 4.32583 0.912508 4.36353C0.876929 4.40123 0.850516 4.44478 0.834859 4.49155C0.819202 4.53832 0.814624 4.58736 0.8214 4.63571C0.828176 4.68405 0.846167 4.73071 0.874289 4.77288C0.902412 4.81504 0.940085 4.85184 0.985043 4.88106C1.03 4.91028 1.08131 4.93132 1.1359 4.94291C1.19048 4.95449 1.2472 4.95639 1.30265 4.94849C1.3581 4.94058 1.41113 4.92304 1.45856 4.89691Z",
    fill: "#111111",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 9.38969C1.6665 9.48546 1.7104 9.57731 1.78854 9.64503C1.86668 9.71275 1.97266 9.7508 2.08317 9.7508H12.9165C13.027 9.7508 13.133 9.71275 13.2111 9.64503C13.2893 9.57731 13.3332 9.48546 13.3332 9.38969C13.3332 9.29392 13.2893 9.20206 13.2111 9.13434C13.133 9.06662 13.027 9.02858 12.9165 9.02858H11.6665V6.36719H10.8332V9.02858H7.9165V6.36719H7.08317V9.02858H4.1665V6.36719H3.33317V9.02858H2.08317C1.97266 9.02858 1.86668 9.06662 1.78854 9.13434C1.7104 9.20206 1.6665 9.29392 1.6665 9.38969Z",
    fill: "#111111",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0918 5.05469H12.9251V5.77691H2.0918V5.05469Z",
    fill: "#111111",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7502 10.4727H1.25016C1.13966 10.4727 1.03368 10.5107 0.955535 10.5784C0.877395 10.6461 0.833496 10.738 0.833496 10.8338C0.833496 10.9295 0.877395 11.0214 0.955535 11.0891C1.03368 11.1568 1.13966 11.1949 1.25016 11.1949H13.7502C13.8607 11.1949 13.9667 11.1568 14.0448 11.0891C14.1229 11.0214 14.1668 10.9295 14.1668 10.8338C14.1668 10.738 14.1229 10.6461 14.0448 10.5784C13.9667 10.5107 13.8607 10.4727 13.7502 10.4727Z",
    fill: "#111111",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22936 4.18259H10.5669L7.77103 2.7887C7.72036 2.76335 7.66287 2.75 7.60436 2.75C7.54585 2.75 7.48837 2.76335 7.4377 2.7887L4.6377 4.18259H5.9752L7.6002 3.3737L9.22936 4.18259Z",
    fill: "#111111",
    fillOpacity: 0.44
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29046_12906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bankIcon.ecdcd818a8470f4ab9650552577025c1.svg";